var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"pg-tabpane-fade","mode":"out-in"}},[(_setup.load)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.active === _vm.name),expression:"active === name"}],staticClass:"pg-tab-pane"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }